module.exports = __webpack_public_path__ + "static/zavicon-6c780c5a46b7c1da34e3fe3737a4d63b.png";